var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconThichUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 17,
  viewBox: "0 0 13 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  clipPath: "url(#clip0_1934_1030)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Right Arrow"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M7.04883 0.884474L7.04883 15.2845C7.04883 15.7245 6.71133 16.0845 6.29883 16.0845C5.88633 16.0845 5.54883 15.7245 5.54883 15.2845L5.54883 0.884474C5.54883 0.444473 5.88633 0.0844736 6.29883 0.0844736C6.71133 0.0844736 7.04883 0.444473 7.04883 0.884474Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M12.2991 6.4845C12.2991 6.6925 12.2241 6.8925 12.0816 7.0525C11.7891 7.3645 11.3166 7.3645 11.0241 7.0525L6.30656 2.0205L1.58156 7.0525C1.28906 7.3645 0.816563 7.3645 0.524063 7.0525C0.231562 6.7405 0.231562 6.2365 0.524062 5.9245L5.77406 0.324499C6.06656 0.0124991 6.53906 0.0124991 6.83156 0.324499L12.0816 5.9245C12.2316 6.0845 12.2991 6.2845 12.2991 6.4925L12.2991 6.4845Z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1934_1030"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 12,
  fill: "white",
  transform: "translate(0.298828 16.0845) rotate(-90)"
})))));
export default SvgIconThichUp;